import isElectron from 'is-electron';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { OpenMobilePopup } from '../../components/OpenMobilePopup/OpenMobilePopup';
import { useAppDispatch } from '../../hooks';
import { PushNotifications } from '../../notifications/PushNotifications';
import { setAlarmData, setLocationData } from '../PanicButton/PanicButtonSlice';
import { didAskedToGoMobileApp, getSsoRedirectLink, isMobileBrowser } from './helpers';
import { RedirectToMobilePopup } from '../../components/RedirectToMobilePopup/RedirectToMobilePopup';
import { localStorageGet, sessionStorageGet } from '../../utils/storage';
import { getServerConfig } from '../../config/region';

export const OpenMobileApp = ({ children }: { children: JSX.Element }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showRedirectToMobile, setshowRedirectToMobile] = useState(false);
  const [searchParams] = useSearchParams();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fromPathname: string = location.state?.from?.pathname || location.pathname;
  const fromSearch: string = location.state?.from?.search ?? location.search ?? '';

  useEffect(() => {
    // checking whether "panic button" session is running
    const panicButtonData = localStorageGet('panicButtonData');
    const panicButtonDataJSON = panicButtonData ? JSON.parse(panicButtonData) : null;
    if (isElectron() && panicButtonDataJSON) {
      if (panicButtonDataJSON.alarmData) {
        dispatch(setAlarmData(JSON.parse(panicButtonDataJSON.alarmData)));
      }
      if (panicButtonDataJSON.location) {
        dispatch(setLocationData(JSON.parse(panicButtonDataJSON.location)));
      }
      navigate('/panic/timer');
    }
  }, [dispatch]);

  useEffect(() => {
    const redirectLink = getSsoRedirectLink(searchParams, false);
    if (redirectLink == null) {
      setShowPopup(isMobileBrowser() && !sessionStorageGet('didAskedToGoMobileApp'));
    } else {
      setshowRedirectToMobile(true);
    }
  }, [searchParams]);

  const onOpenMobileApp = () => {
    didAskedToGoMobileApp();
    setShowPopup(false);
  };
  const onStayWebApp = () => {
    didAskedToGoMobileApp();
    setShowPopup(false);
  };

  return (
    <>
      {isElectron() && <PushNotifications />}
      {showPopup && (
        <OpenMobilePopup
          link={getServerConfig().openMobileAppUrl + fromPathname.substring(1) + (fromSearch ?? '')}
          onOpenMobileApp={onOpenMobileApp}
          onStayWebApp={onStayWebApp}
        />
      )}
      {showRedirectToMobile && (
        <RedirectToMobilePopup
          link={getSsoRedirectLink(searchParams, false)}
        ></RedirectToMobilePopup>
      )}
      {children}
    </>
  );
};
